import React from "react";
import ReactDOM from "react-dom";

export default function renderReactApp(ReactApp, id) {
  const node = document.getElementById(id);
  const config = JSON.parse(node.getAttribute('config'));
  ReactDOM.render(<ReactApp config= { config } />, node);
}
